import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/16/solid";
import {
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
  useState,
} from "react";

import { Button } from "./catalyst/Button";
import { TableCell } from "./catalyst/TableCell";
import { TableRow } from "./catalyst/TableRow";

export const ExpandableTableRow = ({
  children,
  collapsedHeight = 40,
  expandableContent,
  expandedHeight = 200,
  expanderPosition = "start",
  onToggle,
}: {
  children: ReactElement<typeof TableCell>[];
  collapsedHeight?: number;
  expandableContent?: ReactNode;
  expandedHeight?: number;
  expanderPosition?: "end" | "start";
  onToggle?: (isExpanded: boolean) => void;
}): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (): void => {
    const newState = !isExpanded;
    setIsExpanded(newState);

    if (onToggle) {
      onToggle(newState);
    }
  };

  const expanderButton = (
    <TableCell className="w-10 text-left align-top">
      <Button onClick={() => handleToggle()} plain>
        {isExpanded ? (
          <ChevronUpIcon className="h-5 w-5" />
        ) : (
          <ChevronDownIcon className="h-5 w-5" />
        )}
      </Button>
    </TableCell>
  );

  return (
    <>
      <TableRow>
        {expanderPosition === "start" && expanderButton}

        {Children.map(children, (child) => {
          if (isValidElement(child) && child.type === TableCell) {
            return cloneElement(child, {
              style: {
                height:
                  isExpanded && !expandableContent
                    ? expandedHeight
                    : collapsedHeight,
                transition: "height 0.3s ease-in-out",
              },
            } as unknown as ReactElement<typeof TableCell>); // TypeScript fix
          }
          return child;
        })}

        {expanderPosition === "end" && expanderButton}
      </TableRow>

      {expandableContent && isExpanded && (
        <TableRow>
          <TableCell className="p-4" colSpan={children.length + 1}>
            {expandableContent}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
